import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const styles = (theme) => ({
  root: {
    //borderBottom: `solid 1px ${theme.palette.common.inputBorder}`,
    width: '100%',
    zIndex: 1000,
  },
  selected: {
    backgroundColor: theme.palette.common.primary,
  },
  scrollButtons: {
    width: 40,
  },
  tab: {
    textTransform: 'none',
  },
  tabs: {
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

class ScrollableTabs extends React.PureComponent {
  handleChange = (event, newValue) => {
    this.props.onChange(this.props.items[newValue].name);
  };

  render = () => {
    const { classes, items, selected } = this.props;
    return (
      <div className={classes.root}>
        <Tabs
          value={selected}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          classes={{
            indicator: classes.selected,
            scrollButtons: classes.scrollButtons,
            root: classes.tabs,
          }}>
          {items.map((item) => {
            return (
              <Tab label={item.name} key={item.name} className={classes.tab} />
            );
          })}
        </Tabs>
      </div>
    );
  };
}

ScrollableTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array,
  onChange: PropTypes.func,
  selected: PropTypes.number,
};

export default withStyles(styles)(ScrollableTabs);
